import { subDays, isAfter, isSameDay, addDays, isDate } from 'date-fns';
import { IndicatorFailureDTO } from '@atlassiansox/phobos-client-ts';

import { COMPLIANCE_PERIOD_IN_DAYS } from '@/constants';

import { SLOGraphErrorActions } from './enums';

export function generateApiGraphErrorConfig(
  title: string,
  actions: Array<SLOGraphErrorActions>,
  log: IndicatorFailureDTO[],
  error?: string
) {
  const hasLog: boolean = !!log.length;

  return {
    actions: hasLog ? [SLOGraphErrorActions.SeeErrorLog, ...actions] : actions,
    title,
    error: error || (hasLog ? log[0].cause : 'This SLO has experienced an unknown failure'),
    log: hasLog ? log : undefined,
  };
}

export function checkDateIsWithinCompliancePeriod(date: Date | undefined): boolean {
  if (date === undefined) {
    return false;
  }

  const compliancePeriodStartDate = subDays(new Date(), COMPLIANCE_PERIOD_IN_DAYS);
  return isAfter(isDate(date) ? date : new Date(date), compliancePeriodStartDate);
}

export function checkTimestampHasSameDayAsDate(timestamp: Date | undefined, date: Date): boolean {
  if (timestamp === undefined) {
    return false;
  }

  return isSameDay(timestamp, date);
}

// getTimeOfDayUTC and getStartOfDayUTC unashamedly ripped from Glance
export const getTimeOfDayUTC = (
  date: Date,
  hour: number,
  minute: number,
  second: number,
  millisecond: number
) =>
  new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      hour,
      minute,
      second,
      millisecond
    )
  );

export const getStartOfDayUTC = (date: Date) => getTimeOfDayUTC(date, 0, 0, 0, 0);

export function getFollowingDay(date: Date | undefined): Date {
  if (date === undefined) {
    return getStartOfDayUTC(new Date());
  }
  return getStartOfDayUTC(addDays(date, 1));
}

export function getPreviousDay(date: Date | undefined): Date {
  if (date === undefined) {
    return getStartOfDayUTC(new Date());
  }
  return getStartOfDayUTC(subDays(date, 1));
}
